export default __webpack_public_path__ + "static/media/employees.733e636c.md";